/**
 * Testimonial Slider
 * Swiper is loaded globally via theme.liquid.
 * Continuous marquee scroll via requestAnimationFrame.
 */

(function () {
  function cloneSlides(swiperEl) {
    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper || wrapper.dataset.cloned) return null;

    var originalSlides = Array.from(wrapper.children);
    if (!originalSlides.length) return null;

    originalSlides.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      wrapper.appendChild(clone);
    });

    wrapper.dataset.cloned = 'true';
    return originalSlides;
  }

  function initSlider(root) {
    var swiperEl = root.querySelector('[data-ts-swiper]');
    if (!swiperEl || swiperEl.swiper || !window.Swiper) return;

    var originalSlides = cloneSlides(swiperEl);
    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!originalSlides || !originalSlides.length) return;

    var swiper = new window.Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      centeredSlides: false,
      loop: false,
      freeMode: {
        enabled: true,
        momentum: false
      },
      grabCursor: true,
      watchOverflow: false,
      // Turned off: our own RAF loop mutates translate every frame,
      // which the observer would otherwise pick up and "correct" —
      // fighting our manual scroll and making it look stuck.
      observer: false,
      observeParents: false,
      allowTouchMove: true,
      breakpoints: {
        990: {
          spaceBetween: 50
        }
      }
    });

    var loopDistance = 0;

    function measureLoopDistance() {
      var lastOriginal = originalSlides[originalSlides.length - 1];
      var wrapperRect = wrapper.getBoundingClientRect();
      var lastRect = lastOriginal.getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(wrapper).gap) || 0;
      loopDistance = (lastRect.right - wrapperRect.left) + gap;
    }

    // Re-measure a few times after init to catch late image loads
    // (async image_url loading can change slide widths after first paint).
    measureLoopDistance();
    setTimeout(measureLoopDistance, 300);
    setTimeout(measureLoopDistance, 1000);
    window.addEventListener('resize', measureLoopDistance);

    var pxPerSecond = 40;
    var isPaused = false;
    var isDragging = false;
    var lastTimestamp = null;

    swiperEl.addEventListener('mouseenter', function () { isPaused = true; });
    swiperEl.addEventListener('mouseleave', function () { isPaused = false; });
    swiper.on('touchStart', function () { isDragging = true; });
    swiper.on('touchEnd', function () { isDragging = false; });

    function tick(timestamp) {
      if (lastTimestamp === null) lastTimestamp = timestamp;
      var delta = (timestamp - lastTimestamp) / 1000;
      lastTimestamp = timestamp;

      if (!isPaused && !isDragging && loopDistance > 0) {
        var current = swiper.translate;
        var next = current - pxPerSecond * delta;

        if (Math.abs(next) >= loopDistance) {
          next += loopDistance;
        }

        swiper.setTranslate(next);
      }

      requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function initAll() {
    var sections = document.querySelectorAll('.testimonial-slider');
    sections.forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.testimonial-slider');
    if (section) initSlider(section);
  });
})();